module.exports = __webpack_public_path__ + "img/d096313.jpg";